import { render, staticRenderFns } from "./QBadge.vue?vue&type=template&id=14c40922&scoped=true"
import script from "./QBadge.vue?vue&type=script&lang=js"
export * from "./QBadge.vue?vue&type=script&lang=js"
import style0 from "./QBadge.vue?vue&type=style&index=0&id=14c40922&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c40922",
  null
  
)

/* custom blocks */
import block0 from "./QBadge.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports